import { all } from 'redux-saga/effects';
import activitiesSaga from './activities';

export default function* activitiesModuleSaga() {
  yield all([activitiesSaga()]);
}
